import { render } from "./TrackingHistory.vue?vue&type=template&id=2939b29d&scoped=true"
import script from "./TrackingHistory.vue?vue&type=script&lang=js"
export * from "./TrackingHistory.vue?vue&type=script&lang=js"

import "./TrackingHistory.vue?vue&type=style&index=0&id=2939b29d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2939b29d"]])

export default __exports__